import CryptoJS from "crypto-js";


class AES128 {

    static CipheName = "AES/CBC/PKCS5PADDING"; //Name of OpenSSL Cipher
    static CipherLen = 16; //128 bits

    static keyy = toString(process.env.KEY);
    static ivv = toString(process.env.IV);

    static encrypt = function(key,iv,text){

        if (key.length < AES128.CipherLen) {
            let numPad = AES128.CipherLen - key.length;

            for(let i = 0; i < numPad; i++){
                key += "0"; //0 pad to len 16 bytes
            }

        } else if (key.length > AES128.CipherLen) {
            key = key.substring(0, AES128.CipherLen); //truncate to 16 bytes
        }

        var i = CryptoJS.enc.Utf8.parse(iv);
        var k = CryptoJS.enc.Utf8.parse(key);
        var en = CryptoJS.AES.encrypt(text, k, { iv: i,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7 });

        const encrypted = CryptoJS.enc.Base64.stringify(i);

        return en.toString()+"\n:"+encrypted+"\n";
    };
    static formatMoney = function(x){

        x=x.toString();
        var lastThree = x.substring(x.length-3);
        var otherNumbers = x.substring(0,x.length-3);
        if(otherNumbers !== '')
            lastThree = ',' + lastThree;
        var res = otherNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + lastThree;

        return res;
    };

    static decrypt = function (key,iv,text) {

        if (key.length < AES128.CipherLen) {
            let numPad = AES128.CipherLen - key.length;

            for(let i = 0; i < numPad; i++){
                key += "0"; //0 pad to len 16 bytes
            }

        } else if (key.length > AES128.CipherLen) {
            key = key.substring(0, AES128.CipherLen); //truncate to 16 bytes
        }

        const t = text.split("\n");

        const crypted = CryptoJS.enc.Base64.parse(t[0]);

        var i = CryptoJS.enc.Utf8.parse(iv);
        var k = CryptoJS.enc.Utf8.parse(key);
        var de = CryptoJS.AES.decrypt({ciphertext: crypted},k,{ iv: i,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7 });

        return de.toString(CryptoJS.enc.Utf8);
    };

}

export default AES128;